module.exports = __webpack_public_path__ + "img/arrow-right-blue.aeebfa64.svg";